<template>
	<div class="sf-search-layout__body__container">
		<sf-search-layout>
			<el-row :gutter="20">
				<el-col :span="5">
					<plant-select />
				</el-col>
			</el-row>
			<template slot="button">
				<sf-button line icon="search" :onClick="() => searchList()" v-if="isButton_(scrId, 'CR')">
					{{ getButtonMsg_(scrId, 'CR') }}
				</sf-button>
			</template>
		</sf-search-layout>
	</div>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/MenuManagement/store/helpers';
import PlantSelect from './PlantSelect.vue';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: { PlantSelect },
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...serviceMethods,
		searchList(currentPage = 1, pageUnit = 10) {
			this.$sf_toggleLoading(true);
			this.getMenus_({ currentPage, pageUnit })
				.then(header => {
					// view 단에서 성공 시 처리가 필요할 경우 then 사용하여 토스트 처리
					// console.log('@@@@ in view then: ', header);
				})
				.catch(e => {
					// console.log('@@@@ in view error: ', e);
					this.$sf_toast({
						type: 'error',
						message: e.message ? e.message : e
					});
					Promise.reject(e);
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		}
	},
	created() {
		this.getPlants_()
			.then(() => {
				// console.log('111');
				this.searchList();
				this.getCommCodes_({ key: 'systems', codeType: 'SYSTEM' })
					.then(() => {
						this.systems.forEach(row => {
							this.gridScrType.push({
								label: row.commCdName,
								value: row.commCd
							});
						});
					})
					.catch(error => {
						this.$sf_toast({
							type: 'error',
							message: error.message ? error.message : error
						});
						Promise.reject(error);
					});
				this.getCommCodes_({ key: 'useYnList', codeType: 'USE_YN' })
					.then(() => {
						this.useYnList.forEach(row => {
							this.gridUseYnList.push({
								label: row.commCdName,
								value: row.commCd
							});
						});
					})
					.catch(error => {
						this.$sf_toast({
							type: 'error',
							message: error.message ? error.message : error
						});
						Promise.reject(error);
					});
			})
			.catch(error => {
				this.$sf_toast({
					type: 'error',
					message: error.message
				});
				Promise.reject(error);
			});
	},
	watch: {
		langCd() {
			//store 초기화
			this.resetYnState_();
			//다국어 재조회
			this.getCommCodes_({ key: 'systems', codeType: 'SYSTEM' })
				.then(() => {
					this.systems.forEach(row => {
						this.gridScrType.push({
							label: row.commCdName,
							value: row.commCd
						});
					});
				})
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message ? error.message : error
					});
					Promise.reject(error);
				});
			this.getCommCodes_({ key: 'useYnList', codeType: 'USE_YN' })
				.then(() => {
					this.useYnList.forEach(row => {
						this.gridUseYnList.push({
							label: row.commCdName,
							value: row.commCd
						});
					});
				})
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message ? error.message : error
					});
					Promise.reject(error);
				});
		}
	}
};
</script>

<style></style>
